export default __webpack_public_path__ + "static/media/network-graph-vid-2.d55226ba.mp4";